import React from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../components/auth/auth.selector";
import ImportMembers from "../../components/Open-pages/import-members/ImportMembers";

const ImportMembersAdmin = () => {
  const userInfoData = useSelector(selectUser);

  return (
    <>
      <ImportMembers decryptedText={userInfoData} />
    </>
  );
};

export default ImportMembersAdmin;
